export default function(evt) {
    return evt.touches || evt.originalEvent.touches;
};